/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-08T09:20:31+02:00
*/

import prefixAll from 'inline-style-prefix-all'

/**
 * adds prefixes to styles with autoprefixer
 * we use the static prefixer which do not look after the user agent
 * which leads to less file size but adds all available prefixes to an inline-style.
 * It's okay as we use inline-styles sparingly.
 * See more: https://github.com/rofrischmann/inline-style-prefixer/blob/master/docs/API.md#pro-tip
 */
export default {

  /**
     * prefixes the style and sets it to style
     * NOTE: !!! This function is not pure !!!
     * @param  {Object} style object which should get the prefixed style
     * @param  {String} key   style to be prefixed
     * @param  {Any} value    value of the style
     * @return {Object}       style with added prefix
     */
  set(style, key, value) {
    const prefixedStyle = this.get(key, value);
    Object.assign(style, prefixedStyle);
  },

  /**
     * returns an prefixed style object for the passed style
     * @param  {String} key   style to be prefixed
     * @param  {Any} value    value of the style
     * @return {Object}       style object with prefixed styles
     */
  get(key, value) {
    const prefixStyle = {
      [key]: value,
    };
    return this.prefixAll(prefixStyle);
  },

  /**
     * Prefixes the style whole style-object and returns a new
     * object with all the prefixed styles
     * @param  {Object} style object which should be prefixed
     * @return {Object}       new style-object with prefixed style
     */
  prefixAll(style) {
    return prefixAll(style);
  },
};
